// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"d390b840","426":"a8d28d94","972":"86fc267d","978":"01a80997"}[chunkId] + ".chunk.css";
};